define("media/routes/application", ["exports", "@ember/routing/route", "@ember/service", "later/utils/constants"], function (_exports, _route, _service, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
  0; //eaimeta@70e063a35619d71f0,"@ember/routing/route",0,"@ember/service",0,"later/utils/constants"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  let ApplicationRoute = _exports.default = (_class = class ApplicationRoute extends _route.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "mediaItemQuery", _descriptor2, this);
      _initializerDefineProperty(this, "mediaNavigation", _descriptor3, this);
      _initializerDefineProperty(this, "queryPersistence", _descriptor4, this);
      _initializerDefineProperty(this, "router", _descriptor5, this);
      _initializerDefineProperty(this, "segment", _descriptor6, this);
      _initializerDefineProperty(this, "starredMedia", _descriptor7, this);
      _initializerDefineProperty(this, "store", _descriptor8, this);
    }
    activate() {
      this.segment.track('viewed-page', {
        page: 'media-library'
      });
    }
    beforeModel() {
      if (this.currentGroup?.contributor) {
        this.router.transitionTo('cluster.collect.contribute');
      } else {
        this.queryPersistence.updateGroup('media-library', this.currentGroup?.id);
      }
    }
    async model() {
      await this.starredMedia.initStarredMedia();
      return new Promise((resolve, reject) => {
        const params = {
          groupId: this.currentGroup?.id,
          labelIds: this.queryPersistence.getLabelIds('media-library', ''),
          dateFilter: this.queryPersistence.getDateFilter('media-library', 'all'),
          usedUnused: this.queryPersistence.getUsedUnused('media-library', ''),
          mediaTypeFilter: this.queryPersistence.getMediaTypeFilter('media-library', ''),
          searchString: this.queryPersistence.getSearchString('media-library', ''),
          socialProfileIds: this.queryPersistence.getSocialProfileIds('media-library', ''),
          trackEvent: false,
          limit: _constants.MEDIA_ITEMS_LIMIT,
          successCallback: resolve,
          failureCallback: reject
        };
        this.mediaItemQuery.queryWithFilters(params);
      }).catch(); // error handling needs to be improved with errors services when the logging issue is fixed
    }
    setupController(controller) {
      controller.set('allMediaItems', this.store.peekAll('mediaItem'));
      this.mediaNavigation.setNarrowArrows(true);
    }
    deactivate() {
      this.controller.set('showingTableView', false);
      this.mediaNavigation.setNarrowArrows(false);
      this.mediaNavigation.clearMediaItems();
    }
    get currentGroup() {
      return this.auth.currentGroup;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "mediaItemQuery", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "mediaNavigation", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "queryPersistence", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "starredMedia", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
});